// Copyright © 2021 Move Closer

import {
  ConnectorMiddleware,
  FoundResource,
  Headers,
  Injectable,
  IResponse,
  Payload
} from '@movecloser/front-core'

/**
 * @author Łukasz Bęben <lukasz.beben@movecloser.pl>
 */
@Injectable()
export class CaptchaMiddleware implements ConnectorMiddleware {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public afterCall (response: IResponse): void {
    //
  }

  public async beforeCall (resource: FoundResource, headers: Headers, body: Payload): Promise<{ body: Payload; headers: Headers }> {
    if (!resource.meta?.useCaptcha) return { headers, body }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const RECAPTCHA_SITE_KEY = process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY

    if (!RECAPTCHA_SITE_KEY) {
      console.warn('Missing RECAPTCHA_SITE_KEY')
      return { headers, body }
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const token = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'submit' })

    if (!body) return { headers, body }

    // FormData payload
    if (typeof body === 'object' && 'append' in body) {
      body.append('g-recaptcha-response', token)
    }

    // Object payload
    if (typeof body === 'object') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if ('data' in body && typeof body.data === 'object') {
        body.data['g-recaptcha-response'] = token
      } else {
        body['g-recaptcha-response'] = token
      }
    }

    return { headers, body }
  }
}
